import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { BaseComponent } from './../base/base.component';

@Component({
  selector: 'app-unitheader',
  templateUrl: './unitheader.component.html',
  styleUrls: ['./unitheader.component.scss']
})
export class UnitheaderComponent extends BaseComponent implements OnInit {

  @Input() title: string;

  @Input() active;

  @Input() id: number;

  constructor(ele: ElementRef) {
    super(ele);
    this.title = 'Test Selection Wizard';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/unitheader/unitheader.component.ts